// only run code if an element is present
var itemsHeadings = $('.js-item-expandable');

if (itemsHeadings.length > 0) {
    // on heading click toggle content visibility

    // close all items on page load
    $('.c-list-expandable__inner').delay(1000).slideUp(1000);

    itemsHeadings.click(function () {
        // slidePost($('#' + $(this).find('.c-list-expandable__link').data('expandable')));
        // Close all the items
        $('.c-list-expandable__inner').slideUp();
        // Make icon be + again
        $('.division-toggle button').removeClass('tcon-transform');
        // Current item inner content
        var thisItem = $('#' + $(this).find('.c-list-expandable__link').data('expandable'));
        // Only if the card isn't open yet, slideDown.
        if (!thisItem.hasClass('open')) {
            $('#' + $(this).find('.c-list-expandable__link').data('expandable')).slideDown();
            $('#' + $(this).find('.c-list-expandable__link').data('expandable')).addClass('open');
            $(this).find('.division-toggle button').addClass('tcon-transform');
            // All items except this one, the class 'open' should be removed
            $('.c-list-expandable__inner.open').not(thisItem).removeClass('open');
        } else {
            $('.c-list-expandable__inner').removeClass('open');
        }
    });

    // give headings tabindex to make them programmatically focusable
    // itemsHeadings.each(function () {
    //     this.tabIndex = '-1';
    // });
}



// WEBPACK FOOTER //
// ./scripts/routes/components/list-expandable.js